import React from 'react';
import { TableMyNotesView } from './TableMyNotes.view';
import { useQuery } from '@apollo/client';
import { QUERY_GET_MY_NOTE_IN_CLASSE } from '../../../../graphql/query/note/getNoteQuery';
import { MY_ID } from '../../../../helpers/user/authorization';
import { useRefetchData } from '../../../../helpers/refetch/refetchData';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import FrontError from '../../../../helpers/errors/front.error';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import useStyle from './tableMyNotes.style';
import { GetMyNoteInClasseQuery } from '../../../../graphql/generated/graphql';
import { getNoteDefFromQuery } from '../../../../helpers/transformApiResponse/note';

export const TableMyNotes = () => {
  const classes = useStyle();
  const { data, loading, error, refetch } = useQuery<GetMyNoteInClasseQuery>(
    QUERY_GET_MY_NOTE_IN_CLASSE,
    {
      variables: { id: MY_ID }
    }
  );
  useRefetchData(refetch);
  if (loading) return <LoadingContainer variant="TableMyResult" />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new FrontError('TableMyNotes :récupération des notes', error)
        }
        text={"Veuillez recharger l'affichage des Notes"}
        setFeedback
      />
    );
  return (
    <div className={classes.root}>
      <HeaderText text="Mes moyennes" emoji={emojis['CardIndexDividers']} />
      <TableMyNotesView
        noteDef={getNoteDefFromQuery(data.getMyNoteInClasse.note)}
      />
    </div>
  );
};
